
















import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import Component from 'vue-class-component';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { Prop } from 'vue-property-decorator';
import { InfoState } from '@/core';
import idb from '@/services/indexedDb.service';
import { currentUserKey } from '../../../shared/msw-constants';
import { localStorageKeeperService } from '@/shared/auth-service';
import { envCongif } from '@/shared/env.config';

const cssPrefix = 'delete-acc';
@Component({
  components: {
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
  },
})
export default class DeleteAccDialog extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop() deleteAccModal: boolean;
  isIframed:boolean = false;

  closeDialog() {
    this.$emit('closeDeleteAccModal');
  }

  created() {
    this.isIframed = location !== parent.location;
  }
  submit() {
    this.closeDialog();
    const tempToken = localStorage.getItem('redirectarg3');
    localStorage.removeItem('redirectarg3');
    this.$store.dispatch('SnbProfileStoreModule/getSubscriptionCode', { tempToken1 : tempToken, code : '' })
    .then((response : any) => {
      this.$store.commit('stopLoading');
      if (response.msgCode === 'MSWAPP:EMPTYPRODLIST' || response.msgCode === 'GEN:UNMATCHEMAILANDSUBCODE' ||
        response.msgCode === 'GEN:INVALIDSUBSCRIPTIONCODE' || response.msgCode === 'MSWAPP:FAILURE' ||
        response.msgCode === 'MSWAPP:DELETEPRODUCTWARNING') {
        const message : InfoState = { infoMsg : response.msgDesc, infoType: 'failed' };
        this.$store.commit('enqueueMessage', message);
      } else if (response.msgCode === 'MSWAPP:SUBSCRIPTIONEMAILSENTSUCCESS') {
        const message : InfoState = { infoMsg : response.msgDesc, infoType: 'success' };
        this.$store.commit('enqueueMessage', message);
        setTimeout(() => {
          this.deleteUserTokenAndNavigate();
        }, 5500); // tslint:disable-line
      } else if (response.msgCode === 'MSWAPP:DELETESUCCESS') {
        const message : InfoState = { infoMsg : response.msgDesc, infoType: 'success' };
        this.$store.commit('enqueueMessage', message);
        setTimeout(() => {
          this.deleteUserTokenAndNavigate();
        }, 5500); // tslint:disable-line
      } else {
        const message : InfoState = { infoMsg : response.msgDesc, infoType: 'failed' };
        this.$store.commit('enqueueMessage', message);
      }
    });
  }
  cancel() {
    this.closeDialog();
  }
  deleteUserTokenAndNavigate() {
    idb.clearData()
        .then(() => {
          this.resetVueStore();
          localStorage.setItem(currentUserKey, '');
          localStorage.removeItem('supportCasesData');
          localStorage.removeItem('cartCount');
          this.$store.commit('mutate', { property: 'loggedIn', with: false });
          if (localStorageKeeperService.retrieve('showPendo') !== null) {
            localStorageKeeperService.cleanKey('showPendo');
          }
          if (this.isIframed) {
            window.location.href = `${envCongif.msw_url}/muir/login`;
          } else {
            this.$router.push({ path : '/m/login/login-view' });
          }
        });
  }

  resetVueStore() {
    this.$store.commit('startLoading');
    this.$store.dispatch('resetStore');
    this.$store.dispatch('DashBoardStoreModule/resetStore');
    this.$store.dispatch('MswProductsStoreModule/resetStore');
    this.$store.dispatch('DropdownStoreModule/resetStore');
  }
}
